export enum PromocodeType {
    NoComission = 0,
    FreeTokens = 1
}

export var PromocodeTypeLabelMap = new Map<PromocodeType, string>([
    [PromocodeType.NoComission, "No comission"],
    [PromocodeType.FreeTokens, "Free Ripe Growth"],
]);